module.exports = __webpack_public_path__ + "bd15724697842e17376323dc3e7b6e41.svg";